import { useMediaQuery } from '@mui/material';
import { FC } from 'react';
import { Icon, Icons, Typography } from '../../../stories/atoms';
import { RowFlexContainer } from '../../../stories/atoms/containerV2/ContainerV2';
import { Colors, muiTheme } from '../../../theme';
import { StatusCardContainer } from './StatusCard.styles';

export type StatusCardProps = {
  title: string;
  icon: Icons;
  value: number;
  iconColor?: Colors;
  isActive?: boolean;
  onClick?: () => void;
};

export const StatusCard: FC<StatusCardProps> = ({ title, icon, value, iconColor, isActive, onClick }) => {
  const isTablet = useMediaQuery(muiTheme.breakpoints.down('desktop'));
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('tabletPortrait'));

  const padding = isMobile ? '8px 12px' : isTablet ? '12px 16px' : '16px 16px 4px 16px';
  const height = isMobile ? '80px' : '96px';

  return (
    <StatusCardContainer
      data-testid="status-card"
      style={{ padding, height }}
      $isActive={isActive}
      $isClickable={!!onClick}
      onClick={onClick}
      {...(onClick ? { 'aria-pressed': isActive ?? false } : {})}
    >
      <Typography type={isMobile ? 'body3' : 'button'}>{title}</Typography>
      <RowFlexContainer justifyContent="between" alignItems="center">
        <Typography type={isMobile ? 'button' : 'h4'}>{value}</Typography>
        <Icon icon={icon} color={iconColor} size={isMobile ? 'small' : 'medium'} />
      </RowFlexContainer>
    </StatusCardContainer>
  );
};
